import { TaxCode } from '../models/models'
import { Response } from './util/with-response-formatter-interceptor'
import backendConnection from './util/backend-connection'

export const getTaxCodes = (): Promise<Response<TaxCode[]>> =>
    backendConnection.request({
        url: `/tax-codes`,
        method: 'GET',
    })
